var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "logo" }, [
    _c("img", {
      style: { height: `${_vm.logoHeight}px` },
      attrs: { src: _vm.getLogo },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }